import * as React from "react";

import "./line-items-modules.scss";

import {itemEditor, ui} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {lineItemsBaseModules} from "../../../common/line-items-modules/line-items-base-modules";
import {LineItems}            from "../../../common/line-items-modules/ui/line-items";
import {summaryLines}         from "../common/summary-lines-expo";
import { cs } from "@Common/react/chain-services";
import { cx } from "emotion";

export const lineItemsModules = ({templateOptions, item}) => [
    ...lineItemsBaseModules({templateOptions, item}),
    {
        load: ({lineItems, totalQuantity}, rootNext) => cs(
            ["lineItemsCard", ({}, next) => !lineItems.lineItems.length ? rootNext(null) : LineItems({
                item,
                lineItems: lineItems.lineItems,
                qrEnabled: lineItems.qrEnabled,
                selectedLineItems: lineItems.selectedLineItems,
                fullState    : lineItems.state,
                next,
            })],
            ({lineItemsCard}) => rootNext({
                itemEditor: lineItemsCard.itemEditor,
                ui: (
                    <div className={cx("line-items", "line-items-4ro")} xd-qa-type="card" xd-qa-name="Line Items">
                        {lineItemsCard.render?.()}
                    </div>
                ),
                summaryLines: (
                    lineItems.selectedLineItems
                        .map((lineItem) => {
                            const subOptionDevKey = lineItems.state?.value?.current.find((lineItemState) => lineItem.dev_key === lineItemState.dev_key)?.subOptionDevKey;
                            if(subOptionDevKey) {
                                const subOption = lineItem.subOptions.find((subOption) => subOption.dev_key === subOptionDevKey);
                                const unitPrice = (
                                    +(subOption.flatPrice ?? 0) +
                                    +(subOption.unitPrice ?? 0)
                                );
                                return ({
                                    label: `${lineItem.name} - ${subOption.name}`,
                                    unitPrice,
                                    qty: totalQuantity,
                                });
                            }
                            const unitPrice = (
                                +(lineItem.flatPrice ?? 0) +
                                +(lineItem.unitPrice ?? 0)
                            );
                            return ({
                                label: lineItem.name,
                                unitPrice,
                                qty: lineItem.dev_key === 'expedited_production' ? 1 : totalQuantity,
                            });
                        })
                ),
            }),
        ),

        expo: [ui("lineItems"), summaryLines, itemEditor],
        requires: ["lineItems", "totalQuantity", "sampleMailingCard"],
    },
];
